import React from 'react';
import styled from 'styled-components';

import { SlideTitle, SlideText } from 'johari/ui/atoms';

const Johari404 = () => {
  return (
    <>
      <Title>404</Title>
      <SlideText style={{ maxWidth: 340 }}>Ничего не найдено</SlideText>
    </>
  );
};

const Title = styled(SlideTitle)`
  font-size: 102px;
  color: ${p => p.theme.colors.primary} !important;
`;

export default Johari404;
